import { useAutoLockContext } from '@pwc/auto-save-ui';
import { userTokenService } from '@pwc/pwc-deals-web-common';
import { useAutoLockCommentingContext } from 'common/components/AutoLock';

type Lock = {
  userId: number;
  user: string;
};

const useAutoLock = () => {
  const { contentThreadIds, projectId } = useAutoLockCommentingContext();
  const contentThreadId = contentThreadIds[0] || null;
  const autoLock = useAutoLockContext();
  const isReadOnly = userTokenService.isPwcReadOnlyRole(projectId);
  const currentUserId = userTokenService.getUserId();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const lock = autoLock.getLock(contentThreadId!) as Lock;
  const isLocked = !!lock?.userId && String(lock?.userId) !== currentUserId;
  const { user = '' } = lock || {};
  return {
    isLocked,
    lockedBy: user,
    isReadOnly,
  };
};

export default useAutoLock;
